// cookies functions 


function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
var getcontent = getCookie('Recent Search');
var jsonobjs = [];

if (getcontent !== '') {
    jsonobjs = JSON.parse(getcontent);
}

var input_val = document.querySelector(".searchers-data").getAttribute("data-handle");
var final_val2 = document.querySelector(".searchers-data").getAttribute("data-count");

// Check if the input_val already exists in jsonobjs
var existingIndex = jsonobjs.findIndex(function(obj) {
    return obj.value === input_val;
});

if (existingIndex !== -1) {
    // If input_val already exists, remove it from jsonobjs
    jsonobjs.splice(existingIndex, 1);
}

// Create a new item
var item = {
    "value": input_val
};

// Add the new item to jsonobjs
jsonobjs.push(item);

// Set cookie with updated jsonobjs
setCookie('Recent Search', JSON.stringify(jsonobjs), 1);
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('Search_Tab')) {
        var clickedElement = event.target;

        var getattr = clickedElement.getAttribute('data-handle');

        var productGrids = document.querySelectorAll('.template-search__results .product-grid');
        for (var i = 0; i < productGrids.length; i++) {
            productGrids[i].style.display = 'none';
        }

        var targetProductGrid = document.querySelector('.template-search__results .product-grid[data-handle="' + getattr + '"]');
        if (targetProductGrid) {
            targetProductGrid.style.display = 'flex';
        }
    }
});

document.addEventListener('click', function(event) {
    if (event.target.classList.contains('tab-clicked')) {
        var clickedElement = event.target;

        var getattr = clickedElement.getAttribute('data-handle');
              var MObileSearch_Tab  = document.querySelectorAll('.MObileSearch_Tab ');
        for (var i = 0; i < MObileSearch_Tab.length; i++) {
            MObileSearch_Tab[i].classList.remove('active');
        }
clickedElement.parentNode.classList.add('active');
        var productGrids = document.querySelectorAll('.template-search__results .product-grid');
        for (var i = 0; i < productGrids.length; i++) {
            productGrids[i].style.display = 'none';
        }

        var targetProductGrid = document.querySelector('.template-search__results .product-grid[data-handle="' + getattr + '"]');
        if (targetProductGrid) {
            targetProductGrid.style.display = 'grid';
        }
    }
});

// Select all elements with class "sort-custom-icon" and attach a click event listener
document.querySelectorAll(".sort-custom-icon").forEach(function(element) {
    element.addEventListener("click", function() {
        // Toggle the class "mob-sort-active" on the parent element with class "custom-sort_by_filter"
        var parentElement = this.closest(".custom-sort_by_filter");
        if (parentElement) {
            parentElement.classList.toggle("mob-sort-active");
        }
    });
});
document.addEventListener('change', function(event) {
    if (event.target.closest('.sort_by-main-wrapper .input_label_outer-wrapper .input-label-rpeater-data input')) {
        var loc = window.location.href;
        var sortOption = event.target.value;
        var incStr = loc.includes("sort_by");
        var ques = loc.includes("?");
        var previousOption = document.getElementById('SortBy-mobile').value;
        var optName = document.getElementById('SortBy-mobile').getAttribute('name');
       var search_val = document.querySelector(".search__input").value;
        var collectionContent;

        if (incStr && ques) {
            document.getElementById('SortBy-mobile').value = sortOption;
            var newLink = loc.replace('sort_by=' + previousOption, 'sort_by=' + sortOption);
             var sectionid = document.querySelector('aside').getAttribute('data-id');
            console.log(window.location.pathname + '?section_id=' + sectionid + '&' + optName + '=' + sortOption);
            fetch(window.location.pathname + '?q=' + search_val + '&options%5Bprefix%5D=last&' + optName + '=' + sortOption)
                .then(response => response.text())
                .then(data => {
                    const filterHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#ProductGridContainer').innerHTML;
                    collectionContent = document.querySelector('#ProductGridContainer');
                    collectionContent.innerHTML = filterHTML;
                          document.querySelectorAll('.CustomSearch_content').forEach(function(element) {
    var getItemsLength = element.querySelectorAll('.grid__item').length;
    var finalHandle = element.getAttribute('data-handle');
    
    var searchTab = document.querySelector('.MObileSearch_Tab[data-handle="' + finalHandle + '"] span.CountMBspan');
    if (searchTab) {
        searchTab.textContent = getItemsLength;
    }
});
                });
            if (newLink) {
                window.history.replaceState(loc, {}, newLink);
                document.body.classList.remove('sortByPopupOpen', 'overflow-hidden-mobile');
            }
        } else if (incStr && !ques) {
            document.getElementById('SortBy-mobile').value = sortOption;
            var newLink = loc.replace('sort_by=' + previousOption, 'sort_by=' + sortOption);
             var sectionid = document.querySelector('aside').getAttribute('data-id');
            fetch(window.location.pathname + '?q=' + search_val + '&options%5Bprefix%5D=last&' + optName + '=' + sortOption)
                .then(response => response.text())
                .then(data => {
                    const filterHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#ProductGridContainer').innerHTML;
                    collectionContent = document.querySelector('#ProductGridContainer');
                    collectionContent.innerHTML = filterHTML;
                          document.querySelectorAll('.CustomSearch_content').forEach(function(element) {
    var getItemsLength = element.querySelectorAll('.grid__item').length;
    var finalHandle = element.getAttribute('data-handle');
    
    var searchTab = document.querySelector('.MObileSearch_Tab[data-handle="' + finalHandle + '"] span.CountMBspan');
    if (searchTab) {
        searchTab.textContent = getItemsLength;
    }
});
           
                });
            if (newLink) {
                window.history.replaceState(loc, {}, newLink);
                document.body.classList.remove('sortByPopupOpen', 'overflow-hidden-mobile');
            }
        } else {
            document.getElementById('SortBy-mobile').value = sortOption;
            var newLink = loc + '?sort_by=' + sortOption;
             var sectionid = document.querySelector('aside').getAttribute('data-id');
            fetch(window.location.pathname + '?q=' + search_val + '&options%5Bprefix%5D=last&' + optName + '=' + sortOption)
                .then(response => response.text())
                .then(data => {
                    const filterHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#ProductGridContainer').innerHTML;
                    collectionContent = document.querySelector('#ProductGridContainer');
                    collectionContent.innerHTML = filterHTML;
        document.querySelectorAll('.CustomSearch_content').forEach(function(element) {
    var getItemsLength = element.querySelectorAll('.grid__item').length;
    var finalHandle = element.getAttribute('data-handle');
    
    var searchTab = document.querySelector('.MObileSearch_Tab[data-handle="' + finalHandle + '"] span.CountMBspan');
    if (searchTab) {
        searchTab.textContent = getItemsLength;
    }
});
                });
            if (newLink) {
                window.history.replaceState(loc, {}, newLink);
                document.body.classList.remove('sortByPopupOpen', 'overflow-hidden-mobile');
            }
        }
    }
});


var selectElement = document.querySelector("select#SortBy2");
 if (selectElement) {
var options = selectElement.options;
var currentURL = window.location.href;
for (var i = 0; i < options.length; i++) {
    var option = options[i];
    var value = option.value;
    if (currentURL.indexOf(value) > -1) {
        option.selected = true;
    }
}
 }

document.addEventListener("click", function(event) {
    // Check if the clicked element matches the selector
    if (event.target.matches(".mobile_filter_cross span.mobile-facets__close svg")) {
      
        // Remove classes from body
        document.body.classList.remove('filteropen', 'overflow-hidden-mobile');
        
        // Remove classes and attributes from elements
        var disclosureElements = document.querySelectorAll(".mobile-facets__disclosure");
        disclosureElements.forEach(function(element) {
            element.classList.remove("menu-opening");
            element.removeAttribute("open");
        });
    }
});